// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/settings';
const accountsRouter =
  {
    path: roterPre+`/accounts`,
    name: 'accounts',
    meta: {
      icon: '',
      title: '财务'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'reconciliation',
        name: 'AccountsReconciliation',
        meta: {
          title: '财务对账',
          noCache: true
        },
        component: () => import('@/views/accounts/reconciliation/index.vue')
      },
      {
        path: 'statement',
        name: 'AccountsStatement',
        meta: {
          title: '财务账单',
          noCache: true
        },
        component: () => import('@/views/accounts/statement/index.vue')
      },
      {
        path: 'reconciliation/order/:id',
        name: 'ReconciliationOrder',
        component: () => import('@/views/accounts/reconciliation/record.vue'),
        meta: {
          title: '查看订单',
          noCache: true,
          activeMenu: `/merchant/accounts/reconciliation`
        },
        hidden: true
      },
      {
        path: 'capitalFlow',
        name: 'AccountsCapitalFlow',
        meta: {
          title: '资金流水',
          noCache: true
        },
        component: () => import('@/views/accounts/capitalFlow/index.vue')
      },
      {
        path: 'transManagement',
        name: 'AccountsTransManagement',
        meta: {
          title: '转账记录',
          noCache: true
        },
        component: () => import('@/views/accounts/transManage/index.vue')
      },
      {
        path: 'payType',
        name: 'AccountsPayType',
        meta: {
          title: '收款方式',
          noCache: true
        },
        component: () => import('@/views/accounts/payType.vue')
      },
      {
        path: 'deliverymanExtract',
        name: 'DeliverymanExtract',
        meta: {
          title: '配送员提现',
          noCache: true
        },
        component: () => import('@/views/accounts/deliverymanExtract/index.vue')
      },
      {
        path: 'deliverySettlement',
        name: 'DeliverySettlement',
        meta: {
          title: '配送员流水',
          noCache: true
        },
        component: () => import('@/views/accounts/deliverySettlement/index.vue')
      }
    ]
  }
export default accountsRouter as RouteRecordRaw